if(typeof require !== 'undefined') {
    require('../../css/home.css');
}
$(function(){
    var slider = (function(){
        var me = $('.me-report-list');
        var nav = $('.report-nav');
        var copy = $('.me-copy');
        var initWidth,timer = null,pageLenth,total,meIndex;
        return{
            //改变状态
            changeState:function(num){
                if(num == pageLenth){
                    nav.find('.line').eq(0).addClass('active').siblings().removeClass('active');
                    me.stop(true,true).animate({'left':-(num*initWidth)+'px'},700);
                    copy.stop(true,true).animate({'left':0},700,function(){
                        me.css('left',0);
                        $(this).css('left',total+'px');
                    });
                }else{
                    me.stop(true,true).animate({'left':-(num*initWidth)+'px'},700);
                    copy.stop(true,true).animate({'left':total-(num*initWidth)+'px'},700);
                    nav.find('.line').eq(num).addClass('active').siblings().removeClass('active');
                }
            },
            //悬浮事件
            hoverEvent:function(){
                var that = this;
                nav.find('.line').hover(function(){
                    meIndex = $(this).index();
                    clearInterval(timer);
                    that.changeState(meIndex);
                },function(){
                    that.initMove(meIndex);
                });
                this.imgListEvent(me);
                this.imgListEvent(copy);
            },
            //图片悬浮的事件
            imgListEvent:function(obj){
                var that = this;
                obj.hover(function(){
                    meIndex = nav.find('.active').index();
                    clearInterval(timer);
                    that.changeState(meIndex);
                },function(){
                    that.initMove(meIndex);
                });
            },
            //初始化轮播图的长度以及导航的数量
            initItem:function(){
                var item = me.find('.list-item');
                var itemFirst = item.eq(0);
                var itemWidth = itemFirst.outerWidth();
                var itemMarginWidth = parseInt(itemFirst.css('marginRight'),10);
                var length = item.length;
                initWidth = (itemWidth+itemMarginWidth)*6;
                total=(itemWidth+itemMarginWidth)*(length+6);
                pageLenth = Math.ceil(length/6);
                for(var i=0;i<6;i++){
                    copy.append(item.eq(i).clone(true));
                }
                for(var i=0;i<pageLenth;i++){
                    nav.append('<i class="line"></i>');
                }
                nav.find('.line').eq(0).addClass('active');
                me.css('width',total+'px');
                copy.css({'width':initWidth+'px','left':total+'px'});
            },
            //初始化定时器
            initMove:function(num){
                var that = this;
                var number = num;
                timer = setInterval(function(){
                    number++;
                    if(number > pageLenth){
                        number = 1;
                    }
                    that.changeState(number);
                },3000);
            },
            init:function(){
                this.initItem();
                this.initMove(0);
                this.hoverEvent();
            }
        }
    })().init();
})